import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'theme-POLO-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class ThemePOLOSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {


  }

}
